import L from 'leaflet';
import {Cnst} from './Cnst.js';
export default {

install (Vue) {
     //Vue.prototype.$MAX_ITEM_SIZE = 5000;
     Vue.prototype.$itNum = 0;
     Vue.prototype.$itMax = 0;
     Vue.prototype.$mustSave = false;
     Vue.prototype.ch = 'a';
     //Vue.prototype.$zoomIni = 3;
     Vue.prototype.$zoomIni = 10;
     Vue.prototype.$latIni = 20;
     Vue.prototype.$lngIni = 0;
     Vue.prototype.$latIniRu = 55.7558;
     Vue.prototype.$lngIniRu = 37.61769;
     Vue.prototype.$latIniEn = 38.8951;
     Vue.prototype.$lngIniEn = -77.0365;

let osm1Data = {
    name: 'OSM 1',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
};
let osm2Data = {
    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
    attribution: '© <a href="http://www.openstreetmap.fr/">Openstreetmap France</a> | <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
};
let mapTilerData = {
    url: 'https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=mGaqlQJSKCDc37krpVRs#',
    attribution: '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e'
};
let mapboxData = {
    url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaXpoeXVyeSIsImEiOiJjandvbmk0a3oxYzM1NDlvbDJobHp4ZnZ0In0.LzdfJJqJ28HEZltfNj-Bmw',
    attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/'
};
let cartoData = {
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>'
};

/*
let gisData = {
    url: 'http://tile0.maps.2gis.com/tiles?x={x}&y={y}&z={z}',
    attribution: '2GIS'
};
*/
     Vue.prototype.$osm1 = L.tileLayer(osm1Data.url, {attribution: osm1Data.attribution, maxZoom: 18, minZoom: 2});
     Vue.prototype.$osm2 = L.tileLayer(osm2Data.url, {attribution: osm2Data.attribution, maxZoom: 18, minZoom: 2});
     Vue.prototype.$mapbox = L.tileLayer(mapboxData.url, {attribution: mapboxData.attribution, maxZoom: 18, minZoom: 2});

//     Vue.prototype.$gis = L.tileLayer(gisData.url, {attribution: gisData.attribution, maxZoom: 15, minZoom: 2});

     Vue.prototype.$mapTiler = L.tileLayer(mapTilerData.url, { tileSize: 512,
        zoomOffset: -1,
        attribution: mapTilerData.attribution, maxZoom: 18, minZoom: 2, crossOrigin: true }),
     Vue.prototype.$carto = L.tileLayer(cartoData.url, {attribution: cartoData.attribution, maxZoom: 18, minZoom: 2});
     //Vue.prototype.$yndx = new L.Yandex({lang: this.$i18n.locale});
     Vue.prototype.$yandIni = function(lang, reload) {
        Vue.prototype.$yndx = new L.Yandex({lang: lang, reload: reload});
     },
     Vue.prototype.$checkDescSize = function(str) {
        if(typeof(str)=='undefined') return this.$t('ERR_422');
        if(str.length/1000 > Cnst.MAX_ITEM_SIZE) return this.$t('MAX_ITEM_SIZE') + Cnst.MAX_ITEM_SIZE + ' Mb.';
        else return "";
    };
    Vue.prototype.$cleanHtml = function(html) {
        var temp = document.createElement("div");
        temp.innerHTML = html;
        return (temp.textContent || temp.innerText).replace(/[^a-zA-Z0-9а-яА-ЯёЁ!?]+/g, '');
    };
     Vue.prototype.$addEncHyp = function(str) {
         if(typeof(str)=='undefined' || str=='') return "";
         //return encodeURIComponent(str.replace(/-/g,'--').replace(/ /g,'-'));
         return str.replace(/-/g,'--').replace(/ /g,'-');
     };
     Vue.prototype.$rmEncHyp = function(str) {
        if(typeof(str)=='undefined' || str=='') return "";
        //return decodeURIComponent(str.replace(/--/g,'@').replace(/-/g,' ').replace(/@@/g,' - ').replace(/@/g,'-'));
        return str.replace(/--/g,'@').replace(/-/g,' ').replace(/@@/g,' - ').replace(/@/g,'-');
     };

     Vue.prototype.$repl20 = function(str) {
         if(typeof(str)=='undefined' || str=='') return "";
         return str.replace(/%20/g,'-');
     };

     Vue.prototype.$encodeRFC = function(str) {
         if(typeof(str)=='undefined' || str=='') return "";
         return encodeURIComponent(str)
            .replace(
               /[!'()*]/g,
                (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
            );
     };

    //Vue.prototype.$makeUrl = function(userName, itemName, itemType, showDesc, intLoc) {
    Vue.prototype.$makeUrl = function(userName, itemName, itemType) {
        //let item = itemType == 't' ? 'Trip' : 'Place';
        let item = itemType == 't' ? 'Tour' : 'Place';
        //let desc = showDesc == true ? '&showDesc=true' : '';
        //let loc = intLoc == 'en' ? '&intLoc=en' : '';
        //console.log(showDesc, intLoc);
        history.replaceState(
            {},
            null,
            item+'/'+this.$addEncHyp(itemName)+'?author='+this.$addEncHyp(userName)
        )
    }
    Vue.prototype.$showDoc = function(title) {
        this.$router.push({
            path: '/Doc/'+title,
        })
    }
    Vue.prototype.$incSession = async function() {
        var that = this;
        var sessTimer = await setInterval(function(){
            if(!that.$store.state.curUserName) {
                clearInterval(sessTimer);
                return;
            }
            let res = that.$showConfirm(that.$t('CONT_SESS'), 'info', 'success', 'danger', that);
            var idleTimer = setTimeout(function(){
                    clearInterval(sessTimer);
                    clearTimeout(idleTimer);
                    that.$bvModal.hide('idConf');
                    that.$logout();
//            }, 120000);
            }, 240000);
//            }, 5000);
            res.then( async res => {
                clearTimeout(idleTimer);
                if(res) return;
                else {
                    clearInterval(sessTimer);
                    that.$store.commit('setCurUserName', '');
                    that.$logout();
                }
            });
//        }, 2400000);
        }, 3600000);
//        }, 30000);
    }
    Vue.prototype.$showMsg = async function(msg, txtC, btnC) {
        msg = '<span class="msgFntSz">'+msg+'</span>';
        const msgVNode = this.$createElement("div", { domProps: { innerHTML: msg } });
        await this.$root.$bvModal.msgBoxOk([msgVNode], { okVariant: btnC, bodyTextVariant: txtC, bodyClass: 'txtCtr'})
        .catch(() => {})
    }
    Vue.prototype.$showErr = function(msg, status) {
        this.$showMsg(msg, 'info', 'warning');
        if(status===401) this.$timeout();
    }

    Vue.prototype.$showConfirm = async function(msg, txtC, yesC, noC, that) {
        this.boxTwo = ''
        return await this.$bvModal.msgBoxConfirm(msg, {
            id: 'idConf',
            title: ' ',
            size: 'md',
            buttonSize: 'md',
            okTitle: that.$t('YES'),
            cancelTitle: that.$t('NO'),
            okVariant: yesC,
            cancelVariant: noC,
            //headerClass: 'p-2 border-bottom-0',
            titleClass: 'myExp',
            //footerClass: 'p-2 border-top-0',
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
        });
    }

    Vue.prototype.$timeout = async function() {
        this.$store.commit('setCurUserName', '');
        this.$router.push({ path: '/' });
    }
    Vue.prototype.$isCrowler = function() {
        if(navigator.userAgent.includes('Google') || navigator.userAgent.includes('Yandex') || navigator.userAgent.includes('bing')) return true;
        //if(navigator.userAgent.includes('Firefox')) return true;
        else return false;
    }
    Vue.prototype.$logout = async function() {
        try {
            await this.$http.get('/userLogout', {
                params: {
                    lat: this.$store.getters.getCurPos.lat,
                    lng: this.$store.getters.getCurPos.lng,
                    zoom: this.$store.getters.getCurPos.zoom
                }
            });
            this.$store.commit('setCurUserName', '');
            this.$router.push({ path: '/' }).catch(() => {});
        }
        catch(error) {
            this.$showErr(error.response.data);
        }
    }
    Vue.prototype.$serveErr = async function(err) {
        try {
            await this.$http.get('/serveErr', {
                params: { err: err }
            });
            this.$showErr(this.$t('SOME_ERROR'));
        }
        catch(error) {
            this.$showErr(error.response.data);
        }
    }
    Vue.prototype.$chIntLoc = function(newLoc) {
        this.$i18n.locale = newLoc;
        //this.$yandIni(this.$i18n.locale);
        this.$store.commit('setIntLoc', newLoc);

    }
    Vue.prototype.$fmtDateTime = function(dateTime) {
        let date = dateTime.substr(8,2)+'.'+dateTime.substr(5,2)+'.'+dateTime.substr(0,4);
        let time = dateTime.substr(11,2)+':'+dateTime.substr(14,2);
        return date+' '+time;
    }
    Vue.prototype.$updateJC = function() {
        this.$store.commit('setProgress', (100*(this.$itMax-this.$itNum)/this.$itMax+'').substring(0,2));
    }
    Vue.prototype.$savePlaceTilesToServer = function (lat, lng, zoom) {
        //console.log(lat, lng, zoom);
        this.$mustSave=true;
        var tileKeys = [];
        this.$pushKeysAroundPlace(lat, lng, zoom, tileKeys);
        this.$itNum = tileKeys.length;
        this.$itMax = this.$itNum;
        //console.log(tileKeys.length);
        this.$saveTiles(tileKeys, "", "", "");
    }
    // Save places tiles and tile of trip itself
    Vue.prototype.$saveTripPlacesTilesToServer = function(markers, map) {
        //console.log(markers[0].markName);
        this.$mustSave=true;
        var tileKeys = [];
        var visibleKeys = [];
        if(markers.length>1) {
            visibleKeys = this.$getVisibleTilesKeys(map);
            for(var i=0; i<visibleKeys.length; i++)
                tileKeys.push(visibleKeys[i]);
        }
        //this.itNum = tileKeys.length;
        for (var j=0; j<markers.length; j++)	{
            var lat = markers[j]["markLat"];
            var lng = markers[j]["markLng"];
            var zoom = markers[j]["markZoom"];
            this.$pushKeysAroundPlace(lat, lng, zoom, tileKeys);
        }
        this.$itNum = tileKeys.length;
        this.$itMax = this.$itNum;
        this.$saveTiles(tileKeys, "", "", "");
    }
    Vue.prototype.$pushKeysAroundPlace = function(lat, lng, zoom, tileKeys) {
        //var key = this.getTileKey(lat, lng, zoom)+".png";
        var key = this.getTileKey(lat, lng, zoom);
        this.pushKeysAroundTile(key, tileKeys);
        //console.log(key);
    }
    Vue.prototype.pushKeysAroundTile = function (key, tileKeys) {
        var fstSlash = key.indexOf("/");
        var xStart = fstSlash+1;
        var yStart = key.indexOf("/", xStart)+1;
        var zoom = key.substring(0,fstSlash);
        var x = key.substring(xStart,yStart-1);
        var y = key.substring(yStart, key.length-4);
        for(var dx=-2; dx<=2; dx++) {
            for(var dy=-2; dy<=2; dy++) {
                key = zoom+"/"+(parseInt(x)+dx)+"/"+(parseInt(y)+dy)+".png";
                tileKeys.push(key);
                //console.log(key);
            }
        }
    }
    Vue.prototype.getTileKey = function(lat, lng, zoom) {
        var xtile = parseInt(Math.floor( (lng + 180) / 360 * (1<<zoom) ));
        var ytile = parseInt(Math.floor( (1 - Math.log(Math.tan(toRad(lat)) + 1 / Math.cos(toRad(lat))) / Math.PI) / 2 * (1<<zoom) ));
        return "" + zoom + "/" + xtile + "/" + ytile + ".png";
        function toRad(e) {
            return e * Math.PI / 180;
        }
    }
    Vue.prototype.$saveTiles = function(tileKeys, type, itemName, userName) {
        var promises = [];
        var key;
        var tileUrl;
        for (var i = 0; i < tileKeys.length; i++) {
            key = tileKeys[i];
            tileUrl = "https://"+this.ch+".tile.openstreetmap.org/"+key;
            if(this.ch=='a') this.ch='b';
            else if(this.ch=='b') this.ch='c';
            else this.ch='a';
            let that = this;
            (function (i, key, tileUrl) {
                   promises[i] = new Promise(function (resolve, reject) {
                    //console.log("*** "+tileUrl+" "+key);
                    var request = new XMLHttpRequest();
                    request.open('GET', tileUrl, true);
                    request.responseType = 'blob';
                    request.onreadystatechange = function () {
                        if (request.readyState === XMLHttpRequest.DONE) {
                            if (request.status === 200) {
                                resolve(that.$saveTile(key, request.response, type, itemName, userName, that));
                            } else {
                               reject({
                                  status: request.status,
                                  statusText: request.statusText
                                });
                            }
                        }
                    };
                    request.send();
                });
            })(i, key, tileUrl);
        }
		return Promise.all(promises);
    }
    Vue.prototype.$saveTile = function(key, value, type, itemName, userName, that) {
        //console.log(key, value, type, itemName, userName);
        var reader = new window.FileReader();
        reader.readAsDataURL(value);
        //this.$itNum--;
        //this.$updateJC();
        reader.onloadend = function() {
            var base64data = reader.result;
            // Save to application
            if((typeof AndroidInterface)!='undefined') {
                var json = {};
                json['key'] = key;
                json['type'] = type;
                json['src'] = 'osm';
                json['itemName'] = itemName;
                json['userName'] = userName;
                json['data'] = base64data;
                var data = JSON.stringify(json);
                /* eslint-disable */
                AndroidInterface.loadTile(data);
                /* eslint-enable */
                that.$itNum--;
                that.$updateJC();
            }
            // Save to server
            if(that.$mustSave) that.$postTile(key, base64data, that);
         }
         return;
     }
    Vue.prototype.$postTile = function(key, base64data, that) {
        //console.log("loading "+key, that.$itMax, that.$itNum);
        try {
            this.$http.post('/saveTile', {
                "key": key, "data": base64data
            });
            that.$itNum--;
            that.$updateJC();
         } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ItsPlugin: postTile() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    }
    Vue.prototype.$getVisibleTilesKeys = function(map) {
        var bounds = map.getPixelBounds();
        var zoom = map.getZoom();
        var tileSize = 256;
        var tileCoordsContainer = [];
        var nwTilePoint = new L.Point(Math.floor(bounds.min.x / tileSize),
        Math.floor(bounds.min.y / tileSize));
        var seTilePoint = new L.Point(Math.floor(bounds.max.x / tileSize),
        Math.floor(bounds.max.y / tileSize));
        var max = map.options.crs.scale(zoom) / tileSize;
        for (var x = nwTilePoint.x; x <= seTilePoint.x; x++) {
            for (var y = nwTilePoint.y; y <= seTilePoint.y; y++) {
                var xTile = Math.abs(x % max);
                var yTile = Math.abs(y % max);
                tileCoordsContainer.push("" + zoom + "/" + xTile + "/" + yTile+".png");
            }
        }
        return tileCoordsContainer;
    };


  }
}